import React from 'react';

export interface AlertProps {
  type?: 'info' | 'success' | 'warning' | 'critical';
  title?: string;
  children: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({ type = 'info', title, children }) => {
  let bgColor = 'var(--nev-color-info-soft)';
  let borderColor = 'var(--nev-color-info)';
  const textColor = 'var(--nev-color-ink)';

  if (type === 'success') {
    bgColor = 'var(--nev-color-success-soft)';
    borderColor = 'var(--nev-color-success)';
  } else if (type === 'warning') {
    bgColor = 'var(--nev-color-warning-soft)';
    borderColor = 'var(--nev-color-warning)';
  } else if (type === 'critical') {
    bgColor = 'var(--nev-color-critical-soft)';
    borderColor = 'var(--nev-color-critical)';
  }

  const alertStyle: React.CSSProperties = {
    backgroundColor: bgColor,
    borderLeft: `4px solid ${borderColor}`,
    borderRadius: 'var(--nev-radius-control)',
    padding: 'var(--nev-space-4)',
    color: textColor,
    fontFamily: 'var(--nev-font-body)',
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    marginBottom: 'var(--nev-space-4)',
  };

  const titleStyle: React.CSSProperties = {
    fontFamily: 'var(--nev-font-heading)',
    fontWeight: 600,
    marginBottom: 'var(--nev-space-1)',
    fontSize: '1rem',
  };

  return (
    <div role={type === 'critical' ? 'alert' : 'status'} style={alertStyle}>
      {title && <div style={titleStyle}>{title}</div>}
      <div>{children}</div>
    </div>
  );
};
